/* eslint-disable no-useless-escape */
import { smoothScrollToElement } from './scroll';
import 'whatwg-fetch';
import dayjs from 'dayjs';
import _ from 'underscore';
import { accScroll } from './page-accordion';

export const getHTML = (url, data = {},  options = {}) => {
    const args = {
        ...options,
        method: 'GET',
        credentials: 'include',
    };

    if (typeof data == 'object' && Object.keys(data).length) {
        url = `${url}?${params(data)}`;
    }

    return runFetch(url, args, 'text');
};

export const getJSON = (url, data = {},  options = {}) => {
    const args = {
        ...options,
        method: 'GET',
        credentials: 'include',
    };

    if (typeof data == 'object' && Object.keys(data).length) {
        url = `${url}?${params(data)}`;
    }

    return runFetch(url, args);
};

export const postJSON = (url, data = {}, options = {}) => {
    const args = {
        ...options,
        method: 'POST',
        body: data,
        credentials: 'include',
    };

    return runFetch(url, args);
};

export const patchJSON = (url, data = {}, options = {}) => {
    const args = {
        ...options,
        method: 'PATCH',
        body: params(data),
        credentials: 'include',
    };

    return runFetch(url, args);
};

export const putJSON = (url, data = {}, options = {}) => {
    const args = {
        ...options,
        method: 'PUT',
        body: params(data),
        credentials: 'include',
    };

    return runFetch(url, args);
};

export const deleteJSON = (url, data = {}, options = {}) => {
    const args = {
        ...options,
        method: 'DELETE',
        body: params(data),
        credentials: 'include',
    };

    return runFetch(url, args);
};

export const runFetch = (url, args, responseType = 'json') => {
    if (typeof args.body != 'undefined' && args.method != 'GET') {
        if (typeof args.body == 'string') {
            args.headers = {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            };
        } else if (typeof args.body == 'object') {
            args.body = JSON.stringify(args.body);
            args.headers = {
                'Content-Type': 'multipart/form-data',
            };
        }
    }

    const networkError = 'Network Failure. Please Try Again.';
    return fetch(url, args)
        .catch(error => { // handle fetch network failures
            error.response = {
                ok: false,
                body: {
                    error: '',
                    error_code: networkError,
                    status: 'error',
                },
                status: 0,
                statusText: networkError,
            };
            throw error;
        })
        .then(response => {
            if (!response.ok) {
                /* Error format:
                {
                    body: {
                        error: ""
                        error_code: "member not found"
                        status: "error"
                    }
                    ok: false
                    status: 400
                    statusText: ""
                }
                */
                return response.json().then(json => {
                    return Promise.reject({
                        status: response.status,
                        ok: false,
                        statusText: response.statusText,
                        body: json,
                    });
                });
            }

            if (responseType == 'json') {
                return response.json().catch(() => {
                    return {};
                });
            } else if (responseType == 'text') {
                return response.text();
            }

            return response;
        })
        .then(result => {
            return result;
        });
};

export const truncate = (str, max) => {
    if (!str || str.length <= max) {
        return str + ' ';
    }

    const charLimit = str.substring(0, max);
    const wordLimit = Math.min(charLimit.length, charLimit.lastIndexOf(' '));

    return charLimit.substring(0, wordLimit).trim() + '… ';
};

export const attributesToObject = (attrs) => {
    return Array.prototype.reduce.call(attrs, (obj, attr) => {
        obj[attr.name] = attr.value;
        return obj;
    }, {});
};

export const bind = (context, names) => {
    names.forEach((name) => {
        const original = context[name];
        context[name] = function bound() {
            return original.apply(context, arguments);
        };
    });
};

export const params = (obj) => {
    let string = '';

    Object.keys(obj).map(key => {
        if (obj[key] == null) {
            string = `${string}${key}=&`;
        } else if (typeof obj[key] == 'object') {
            Object.keys(obj[key]).map(k => {
                string = `${string}${key}=${encodeURIComponent(obj[key][k])}&`;
            });
        } else {
            string = `${string}${key}=${encodeURIComponent(obj[key])}&`;
        }
    });

    return string.replace(/&$/, '');
};

export const hasTouchEvents = 'ontouchstart' in window || 'onmsgesturechange' in window;

export const payloadToParams = (payload) => {
    let data = {};

    Object.keys(payload).forEach(key => {
        if (typeof payload[key] == 'object') {
            Object.keys(payload[key]).forEach(k => {
                data[`${key}[${k}]`] = payload[key][k];
            });
        } else {
            data[key] = payload[key];
        }
    });

    return params(data);
};

export const ordinal = (num) => {
    const j = num % 10;
    const k = num % 100;

    if (j == 1 && k != 11) {
        return num + 'st';
    }

    if (j == 2 && k != 12) {
        return num + 'nd';
    }

    if (j == 3 && k != 13) {
        return num + 'rd';
    }

    return num + 'th';
};

export const shuffle = (array) => {
    let m = array.length;
    let t, i;

    while (m) {
        i = Math.floor(Math.random() * m--); // Pick a remaining element…

        // And swap it with the current element.
        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }

    return array;
};

export const nl2br = (text) => {
    if (typeof text === 'string') {
        return text.replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br />$2');
    }

    return null;
};

export const slugify = (string) => {
    const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
    const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
    const p = new RegExp(a.split('').join('|'), 'g');

    return string.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, '-and-') // Replace & with 'and'
        .replace(/[^\w\-]+/g, '') // Remove all non-word characters
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
        .replace(/\'/g, ''); // Remove single quotes '
};

export const inViewport = (selector) => {
    const element = document.querySelector(selector);

    if (element) {
        const bounding = element.getBoundingClientRect();

        if (
            bounding.top >= 0
            &&
            bounding.left >= 0
            &&
            Math.round(bounding.right) <= (
                window.innerWidth
                ||
                document.documentElement.clientWidth
            )
            &&
            Math.round(bounding.bottom) <= (
                window.innerHeight
                ||
                document.documentElement.clientHeight
            )
        ) {
            return true;
        }
    }

    return false;
};

export const getBirthTime = (hour, minute, ampm) => {
    if (!isNaN(parseInt(hour, 10)) && !isNaN(parseInt(minute, 10))) {
        let birth_time_hour = hour;

        if (parseInt(hour, 10) == 12) {
            birth_time_hour = ampm == 'am' ? 0 : 12;
        } else if (ampm == 'pm'){
            birth_time_hour = parseInt(hour, 10) + 12;
        }

        return birth_time_hour.toString().padStart(2, 0) + ':' + minute + ':00';
    }

    return null;
};

export const getBirthDate = (month, day, year) => {
    if (
        !isNaN(parseInt(month, 10))
        &&
        !isNaN(parseInt(day, 10))
        &&
        !isNaN(parseInt(year, 10))
    ) {
        const birth_date = dayjs(
            `${year}-${month.toString().padStart(2, 0)}-${day.toString().padStart(2, 0)}`,
            'YYYY-MM-DD'
        ).format('YYYY-MM-DD');

        return birth_date;
    }

    return null;
};

export const diff = (object, base) => {
    /**
     * Deep diff between two object, using underscore
     * @param  {Object} obj1 Object compared
     * @param  {Object} obj2 Object to compare with
     * @return {Object}      Return a new object who represent the diff
     */
    const changes = (object, base) => (
        _.pick(
            _.mapObject(object, (value, key) => (
                (!_.isEqual(value, base[key]))
                    ? (
                        (_.isObject(value) && _.isObject(base[key]))
                            ? changes(value, base[key])
                            : value
                    )
                    : null
            )),
            (value) => (value !== null)
        )
    );

    return changes(object, base);
};

export const states = {
    USA: {
        AL: 'Alabama',
        AK: 'Alaska',
        AR: 'Arkansas',
        AZ: 'Arizona',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'Dist of Columbia',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        PR: 'Puerto Rico',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia',
        WA: 'Washington',
        WI: 'Wisconsin',
        WV: 'West Virginia',
        WY: 'Wyoming',
    },
};

export const months = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
};

export const days = [...Array(32).keys()].slice(1);

export const hours = [...Array(13).keys()].slice(1);

export const minutes = [...Array.from(Array(60), (value, key) => (key.toString().padStart(2, 0)))];

export const ampm = {am: 'AM', pm: 'PM'};

export const timezones = {
    '-10.00': 'Hawaii (GMT -10:00)',
    '-9.00': 'Alaska (GMT -09:00)',
    '-8.00': 'Pacific Time (GMT -08:00)',
    '-7.00': 'Mountain Time (GMT -07:00)',
    '-6.00': 'Central Time (GMT -06:00)',
    '-5.00': 'Eastern Time (GMT -05:00)',
    '-4.00': 'Atlantic (GMT -04:00)',
    '-3.50': 'Newfoundland Time (GMT -03:30)',
    '-3.00': 'Buenos Aires (GMT -03:00)',
    '-2.00': 'Mid-Atlantic (GMT -02:00)',
    '-1.00': 'Azores (GMT -01:00)',
    '0.00': 'London (GMT)',
    '1.00': 'Paris (GMT +01:00)',
    '2.00': 'Athens (GMT +02:00)',
    '3.00': 'Moscow (GMT +03:00)',
    '4.00': 'Abu Dhabi (GMT +04:00)',
    '5.00': 'Bombay (GMT +05:00)',
    '5.50': 'New Delhi (GMT +05:30)',
    '6.00': 'Almathy (GMT +06:00)',
    '6.50': 'Burma (GMT +06:30)',
    '7.00': 'Bangkok (GMT +07:00)',
    '8.00': 'Hong Kong | Perth (GMT +08:00)',
    '9.00': 'Tokyo (GMT +09:00)',
    '9.50': 'Adelaide (GMT +09:30)',
    '10.00': 'Sydney (GMT +10:00)',
    '11.00': 'Magadan (GMT +11:00)',
    '12.00': 'Auckland | Fiji (GMT +12:00)',
    '-11.00': 'Midway (GMT -11:00)',
};

export const spyScrolling = () => {
    const navRight = document.querySelector('nav-right');

    navRight.onscroll = () => {
        const sections = document.querySelectorAll('nav-right > div');
        const scrollPos = navRight.scrollTop;

        for (let s in sections) {
            if (sections[s].offsetTop <= scrollPos) {
                const active = document.querySelector('nav-left a.active');
                if (active && active.classList) {
                    active.classList.remove('active');
                }

                const link = document.querySelector(`nav-left .nav-left-${slugify(sections[s].id.replace('nav-', ''))}`); //eslint-disable-line max-len
                if (link && link.classList) {
                    link.classList.add('active');
                }
            }
        }
    };
};

export const asComProducts = [
    'astrology-compatibility-redux',
    'astrology-compatibility-sample',
    'relationship-potential-redux',
    'love-languages-redux',
    'relationship-dynamics-redux',
];

//use hashes that start with '!' to trigger smoothScrollToElement on page load
if (window.location.hash && window.location.hash.match(/\!/)) {
    const hash = window.location.hash.replace(/\!/, '');
    try {
        const target = document.querySelector(hash);

        if (target) {
            smoothScrollToElement(target, true);
        }
    } catch(e) {
        // ignore invalid hash
    }
}

/* eslint-enabled no-useless-escape */
export const isValidEmail = (email) => {
    /* eslint-disable max-len, no-useless-escape */
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    /* eslint-enable max-len, no-useless-escape */
    if (regex.test(email)) {
        return true;
    }

    return false;
};
/* eslint-enabled no-useless-escape */

export const gfxURL = 'https://gfx.tarot.com/images';

if (hasTouchEvents && window.innerWidth >= 900) {
    document.querySelectorAll('nav-bar-full a.nav-item:not(.psychic-advice)')
        .forEach(link => link.removeAttribute('href'));

    window.addEventListener('touchstart', (e) => {
        const activeItems = document.querySelectorAll('a.nav-item.active');
        if (e.target.classList.contains('nav-item') && e.target.classList.contains('active')) {
            document.location.href = e.target.dataset.href;
        } else if (e.target.classList.contains('nav-item')) {
            activeItems.forEach(a => a.classList.remove('active'));
            e.target.classList.add('active');
        } else {
            activeItems.forEach(a => a.classList.remove('active'));
        }
    });
}

export const img_width_height = (url) => {
    const dimensions = url.match(/[0-9]+x[0-9]+/g);

    return dimensions ? dimensions[dimensions.length - 1].split('x') : ['auto', 'auto'];
};

export const checkLocationData = (states, value) => {
    return states && !_.contains(Object.keys(states), 'line') && !value;
};

export const reportGoTo = (e) => {
    if (e.target && e.target.hash) {
        accScroll(e.target.hash.replace('#', ''), 300);
    }
};